import { render, staticRenderFns } from "./AuthenticationForm.vue?vue&type=template&id=35b8346a&scoped=true&"
import script from "./AuthenticationForm.vue?vue&type=script&lang=js&"
export * from "./AuthenticationForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationForm.vue?vue&type=style&index=0&id=35b8346a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8346a",
  null
  
)

export default component.exports